import React from 'react';
import { Card, Avatar, Button } from 'antd';
import {
    MailOutlined,
    PhoneOutlined,
    CalendarOutlined,
    InfoCircleOutlined,
    RocketOutlined
} from '@ant-design/icons';
import { cn } from '../../../../utils/cn';
import { getInitials } from '../../../../utils/helper';
import { formatDateTime } from '../../../../utils/functions';

const EnhancedLeadsSentCardView = ({
    record,
    onCardClick,
}) => {
    const initials = getInitials(record.name);
    return (
        <Card
            hoverable
            className="h-full relative"
            onClick={() => onCardClick && onCardClick(record)}
        >
            <div className="space-y-3 sm:space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-2 sm:space-x-3 overflow-hidden">
                        <Avatar
                            size={40}
                            className={cn("flex-shrink-0 font-semibold text-base sm:text-lg sm:w-12 sm:h-12", record.originalData?.LeadsInformation?.photo ? "" : "!bg-primary")}
                            src={record.originalData?.LeadsInformation?.photo ?? ""}
                        >
                            {initials}
                        </Avatar>
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-sm sm:text-base mb-1 truncate" title={record.name}>
                                {record.name || "N/A"}
                            </h3>
                            {record.destination && (
                                <p className="text-gray-500 text-xs sm:text-sm mb-0 truncate flex items-center gap-1" title={record.destination}>
                                    <RocketOutlined /> {record.destination}
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                {/* Contact Info */}
                <div className="space-y-1.5 sm:space-y-2 border-b border-gray-200 pb-2 sm:pb-3">
                    <div className="flex items-center text-xs sm:text-sm text-gray-600">
                        <MailOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.email ?? "user-email"}>{record.email ?? "-"}</span>
                    </div>
                    <div className="flex items-center text-xs sm:text-sm text-gray-600">
                        <PhoneOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.phone ?? "user-phone"}>{record.phone ?? "-"}</span>
                    </div>
                </div>

                {/* Event Details Section */}
                <div className="space-y-2 sm:space-y-3">
                    {/* Destination */}
                    <div className="flex items-center justify-between">
                        <span className="text-xs sm:text-sm text-gray-600 font-medium">
                            Destination:
                        </span>
                        <span className="text-xs sm:text-sm text-gray-700 truncate max-w-[60%] capitalize" title={record.destination}>
                            {record.destination ?? "-"}
                        </span>
                    </div>

                    {/* Sent At */}
                    <div className="flex items-center justify-between pt-1">
                        <span className="text-xs sm:text-sm text-gray-600 font-medium">
                            <CalendarOutlined className="mr-1" />
                            Sent At:
                        </span>
                        <span className="text-xs sm:text-sm text-gray-700">
                            {record.sentAt}
                        </span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedLeadsSentCardView;
